import { render, staticRenderFns } from "./pun.vue?vue&type=template&id=3ca16af3&"
import script from "./pun.vue?vue&type=script&lang=js&"
export * from "./pun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports